export class CustomerVaultAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "AccountState",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CustomerVaultAccount.attributeTypeMap;
    }
    constructor() {
    }
}
